import ProductService from "@/services/product.service.js";
import ProductCategoryService from "@/services/productCategory.service.js";
// import store from "@/stores/index.js";

export default class ProductUsecase {
  constructor () {
    this.productService = new ProductService();
    this.productCategoryService = new ProductCategoryService();
  }

  async getCategories (clientGroupId) {
    const res = await this.productCategoryService.list(clientGroupId);
    return res;
  }

  async getProductDisplaySetting (clientGroupId) {
    const res = await this.productService.productDisplaySetting(clientGroupId);
    return res;
  }

  async getProductDisplaySettingSource (clientGroupId) {
    const res = await this.productService.productDisplaySettingSource(clientGroupId);
    return res;
  }

  async getProducts (option) {
    const res = await this.productService.list(option);
    return res;
  }

  async updateProductDisplaySetting (param) {
    const res = await this.productService.updateProductDisplaySetting(param);
    return res;
  }

  async updateProductDisplaySettingSourceUpdate (param) {
    const res = await this.productService.productDisplaySettingSourceUpdate(param);
    return res;
  }
}
